<template>
  <div>
    <div class="project-list">
      <div class="project-item" :class="{'border-right': i !== list.length-1 && (i+1)%3 !==0}" v-for="(v, i) in list" :key="i" @click="goArtcle(v)">
        <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/fileimg.png')">
        <div class="txt-line-2 battle-title">{{v.title}}</div>
        <div class="txt-line-1 sub-title">{{v.described}}</div>
      </div>
    </div>
    <div class="news-list-item-wrap">
        <div class="news-list-item" @click="goArtcle(v)" :class="{'border-bottom': index!==list.length-1}" v-for="(v,index) in list" :key="index">
          <div class="news-list-item-img">
            <img class="bg-img" :src="v.imgUrl || '/a'"  @error="imgError('/img/newimg.png')">
          </div>
          <div class="news-list-item-text">
            <div class="title">{{v.title}}</div>
            <div class="flex">
              <div style="width: 50%;" class="subTitle txt-line-2">{{v.described !== 'undefiend' ? v.described : ''}}</div>
              <div class="detail">了解详情></div>
            </div>
           </div>
        </div>
    </div>
    <div class="project-pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getArticleListByColId } from "@/api/project";
import { imgError } from "@/assets/utility";

export default {
  props: {
    colid: String,
  },
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 30,
      total: 0,
    };
  },
  mounted() {},
  methods: {
    loadData(pId) {
      getArticleListByColId(pId, this.currentPage, this.pageSize).then(
        (res) => {
          if (res) {
            this.list = res.rows;
            this.total = res.total - 0;
          }
        }
      );
    },
    goArtcle(pData) {
      this.$router.push(`/article/${pData.id}`);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.loadData(this.colid);
    },
    imgError(pUrl) {
      imgError(pUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.border-bottom {
    border-bottom: 1px solid #bfbfbf;
}
@media only screen and (min-width: 768px) {
  .news-list-item-wrap {
    display: none;
  }
  .battle-title{
    color: #282828;
    font-size: rem(20);
    font-weight: 400;
    height: rem(52);
    margin:rem(35) 0 rem(30) 0;
  }
  .sub-title {
    color:#999999;
    font-size: rem(16)
  }
  .project-list {
    .project-item {
      margin-right: rem(30);
      padding-right: rem(30)
    }
  }
}
@media only screen and (max-width: 768px) {
  .project-list {
    display: none;
  }
  .title {
    margin-bottom: 10px!important;
  }
}
</style>